<template>
  <ClientOnly v-if="isVisible">
    <div class="war-room-mobile-app-banner-aside">
      <CloseIcon class="war-room-mobile-app-banner-aside__close" @click="handleClose" />
      <a
        :href="link"
        class="war-room-mobile-app-banner-aside__link"
        target="_blank"
        rel="nofollow noopener noreferrer"
        @click="sendEvent"
      >
        <img alt="QR code" src="./images/qr.png" width="68" class="war-room-mobile-app-banner-aside__qr" />
        <img
          alt="Apple appstore"
          src="./../images/appstore.png"
          width="100"
          class="war-room-mobile-app-banner-aside__app-store"
        />
      </a>
    </div>
  </ClientOnly>
</template>

<script lang="ts">
import { defineComponent } from '@nuxtjs/composition-api';
import MobileAppBannerMixin from '@/components/partials/war-room/WarRoomMobileAppBanner/mobileAppBannerMixin';

const TOOLTIP_NAME = 'mobile-app-banner-aside';

export default defineComponent({
  name: 'WarRoomMobileAppBannerAside',
  mixins: [MobileAppBannerMixin(TOOLTIP_NAME)],
});
</script>

<style lang="scss" scoped>
.war-room-mobile-app-banner-aside {
  position: relative;
  z-index: 1;

  &__close {
    position: absolute;
    right: 6px;
    top: 6px;
    width: 16px;
    height: 16px;
    color: var(--gray-50);
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: var(--gray-35);
    }
  }

  &__link {
    display: block;
    padding: 16px calc(100% - 100px - 16px) 16px 16px;
    border-radius: 8px;
    background-image: url('./images/phone.png'), linear-gradient(180deg, #080d16 0%, #05142f 100%);
    background-repeat: no-repeat;
    background-size: calc(100% - 100px - 32px), auto;
    background-position: 124px 8px, 0;

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
      background-image: url('./images/phone@2x.png'), linear-gradient(180deg, #080d16 0%, #05142f 100%);
    }
  }

  &__qr {
    display: block;
    width: 68px;
    height: auto;
    margin: 0 auto 16px auto;
  }

  &__app-store {
    display: block;
    width: 100px;
    height: auto;
  }
}
</style>
